// REACT-JSS THEME
export default {
  '@global': {
    body: {
      fontFamily: 'Roboto',
      margin: '0',
    },
    '.lui-dialog__footer': {
      height: 'auto !important',
    },
    '.lui-dialog-container': {
      padding: '0px',
    },
    '.lui-dialog__body': {
      padding: 0,
    },
    'summary::-webkit-details-marker': {
      // display: 'none',
    },
    // details: {
    //   transition: 'all 0.15s ease',
    // },
    // open: {
    //   transition: 'all 0.15s ease',
    // },
    '.qv-st-header': {
      // display: 'none',
    },
    '.njs-action-toolbar-popover': {
      backgroundColor: '#f1f0f0 !important',
    },
    '.njs-cell-action[title="Cancel selection"]': {
      color: 'red !important',
    },
    '.njs-cell-action[title="Confirm selection"]': {
      color: 'green !important',
    },
    th: {
      textAlign: 'left',
      cursor: 'text',
    },
  },
};
